/**
 * ニュースのデザインガイドで管理されている色をコピーしています。
 *
 * @see https://www.figma.com/file/msFY2U9mc4N7lp0tnDvXo8/UI%2FUX%E3%82%AC%E3%82%A4%E3%83%89_web?type=design&node-id=0-1&mode=design&t=vxosLF5Hz9wdH4kN-0
 */
export const NewsDesignToken = {
  color: {
    light: {
      palette: {
        bg_lv1_common: '#FFFFFF',
        bg_lv2_common: '#F7F7F7',
        bg_largeimage_common: '#333333',
        bg_hover_normal_pc: '#F9F9F9',
        bg_hover_subColumn_pc: '#EAEEF2',
        bg_base_sp: '#E5EAEE',
        bg_livePlayer_common: '#333333',
        thumbnail_normal_common: '#EFEFEF',
        thumbnail_normal_border_common: 'rgba(0,0,0,0.06)',
        thumbnail_movie_common: '#000000',
        thumbnail_photo_common: '#4A4A4A',
        text_base_common: '#333333',
        text_sub_lv1_common: '#949494',
        text_sub_lv2_common: '#666666',
        text_alert_common: '#D0021B',
        text_blue_common: '#1A75FF',
        text_white_common: '#FFFFFF',
        text_livePlayer_common: '#FFFFFF',
        text_liveProgram_common: '#A9A9A9',
        btn_simple_bg_common: '#FFFFFF',
        btn_simple_border_common: '#BBBBBB',
        btn_simple_text_common: '#444444',
        btn_current_bg_common: '#444444',
        btn_current_text_common: '#FFFFFF',
        btn_disabled_bg_common: '#E8E8E8',
        btn_disabled_text_common: '#AAAAAA',
        btn_purchase_bg_common: '#99CC00',
        btn_purchase_text_common: '#FFFFFF',
        btn_primary_bg_common: '#1A75FF',
        btn_primary_text_common: '#FFFFFF',
        btn_normal_bg_common: '#FFFFFF',
        btn_normal_border_common: '#1A75FF',
        btn_normal_text_common: '#1A75FF',
        btn_delete_bg_common: '#eb0026',
        btn_delete_border_common: '#eb0026',
        btn_delete_text_common: '#fff',
        information_notice_bg_common: '#EBF0FA',
        information_notice_border_common: '#B0C3EB',
        information_warning_bg_common: '#FFEFB0',
        information_warning_border_common: '#FFD325',
        information_warning_icon_common: '#FFAB00',
        ranking_1_common: '#f14b43',
        ranking_2_common: '#DD6214',
        ranking_3_common: '#B97904',
        ranking_default_common: '#EBEBEB',
        breaking_common: '#25CC9C',
        breaking_icon_common: '#FFFFFF',
        bor_lv1_pc: '#F0F0F0',
        bor_lv2_pc: '#E1E1E1',
        bor_lv1_sp: '#E5EAEE',
        bor_lv2_sp: '#D5DAE1',
        bor_quote_common: '#B7B7B7',
        bor_notice_pc: '#5D83A1',
        brand_common: '#3474CE',
        link_pc: '#0033CC',
        link_hover_pc: '#CC3434',
        link_visited_pc: '#663399',
        link_hover_bg_pc: '#F9F9F9',
        link_sp: '#006CCC',
        link_visited_sp: '#663399',
        link_tab_sp: '#696969',
        link_gray_visited_sp: '#949494',
        form_default_common: '#BBBBBB',
        form_focus_common: '#1A75FF',
        loading_gray_common: '#DDDDDD',
        icon_pc: '#949494',
        icon_sp: '#949494',
        icon_livePlayer_button_sp: '#A9A9A9',
        icon_gray_lv1_common: '#D5D5D5',
        icon_gray_lv2_common: '#CCCCCC',
        icon_gray_lv3_common: '#444444',
        comment_default_common: '#3474CE',
        comment_many_common: '#F76564',
        breaking_bg_common: '#FFF7F9',
        breaking_bor_common: '#FFC5D1',
        'btn-sns-bg-twitter': '#1DA1F2',
        'btn-sns-bg-facebook': '#1877F2',
        'btn-sns-bg-line': '#06C755',
        'btn-sns-bg-hatena': '#00A4DE',
        photo_number_common: '#000000',
        photo_pager_bg_common: '#6E6E6E',
        photo_pager_bg_hover_common: '#6E6E6E',
        bor_photo_current_common: '#FFC926',
        trend_label_common: '#DE4445',
        listMark_liveProgram_common: '#D8D8D8',
        bg_footerNavigation_pc: '#4E555D',
        bg_footerNavigation_externalLink_pc: '#494E54',
        bor_footerNavigation_pc: '#3C4147',
        text_footerNavigation_externalLink_pc: '#DBDBDB',
        bg_footer_sp: '#EFEFEF',
        categoryTab_notCurrent_border_sp: 'rgba(255,255,255,0.2)',
        categoryTab_notCurrent_bg_sp: 'rgba(255,255,255,0.2)',
        icon_ReactionButton_pressed: '#FF5260',
        icon_ReactionButton: 'rgba(0, 0, 0, 0.6)',
        bg_ReactionButtonTip_pressed_common: 'rgba(255,82,96,1)',
        bg_ReactionButtonTip_common: 'rgba(0, 0, 0, 0.43)',
        bg_ReactionButtonTutorial_common: 'rgba(0, 0, 0, 0.73)',
        icon_comment_thumbsUpButton_common: '#FF5260',
        polls_graph_lv1_common: '#3474CE',
        polls_graph_lv2_common: '#38A8E1',
        polls_graph_lv3_common: '#4CCDD9',
        polls_graph_lv4_common: 'linear-gradient(to bottom, #38a8e1, #3474ce)',
        polls_icon_voting_common: '#f14b43',
        ranking_default_text_common: '#6A6A6A',
        polls_icon_result_common: '#868686',
        oldColor_icon_live: '#25CC9C',
        oldColor_icon_new: '#FEAE00',
        oldColor_icon_pay: '#939AA5',
        oldColor_alert: '#EB0026',
        expert_label_text: '#3474ce',
        expert_label_bg: 'rgb(52 115 206 / 20%)',
        aiagent_common: '#7462e8',
        ant_aigradient_lv1: '#E9ACC8',
        ant_aigradient_lv2: '#DD5888',
        ant_aigradient_lv1_gradation: 'linear-gradient(90deg, #E9ACC8 0%, #B6B2F5 50%, #9BBFFD 100%);',
        ant_aigradient_lv2_gradation: 'linear-gradient(84deg, #DD5888 0%, #7462E8 50%, #3083FD 100%);'
      }
    },
    dark: {}
  }
} as const;
